import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './SignInCertificate.module.scss'
import { Form, Icon } from '@digicert/dcone-common-ui'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons'

const CertificateError = (): ReactElement => {
  const { t } = useTranslation();
  const { search } = useLocation()
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(search)


   const onBack = (e) => {
      e.preventDefault()
      navigate(-1)
    }

  const onSubmit = (e):void => {
    e.preventDefault()
  }

  return (
    <section className={styles.signInCert}>
      <Form center className={styles.form} onSubmit={(e) => {onSubmit(e)}}>
        <h1 className={styles.heading}>{t('certificateError.heading')}</h1>
        {searchParams.get('login_hint') && (
          <div className={styles.userNameBackGroup}>
            <Link to='#back' onClick={onBack} className={styles.userNameBack}>
              <Icon icon={faArrowLeft} color='blue' size='lg'/>
              <p>{searchParams.get('login_hint')}</p>
            </Link>
          </div>
        )}
        <h4 className={styles.subHeading}>{t('certificateError.subHeading')}</h4>

        <p className={styles.list}>{t('certificateError.expired')}</p>
        <ul>
            <li className={styles.list}>{t('certificateError.pointOne')}</li>
            <li className={styles.list}>{t('certificateError.pointTwo')}</li>
            <li className={styles.list}>{t('certificateError.pointThree')}<a href='https://docs.digicert.com/en/platform-overview/manage-your-accounts/digicert-account/sign-in-methods/two-factor-authentication/troubleshoot-client-certificate-authentication.html'>{t('certificateError.troubleshootLink')}</a></li>
        </ul>
      </Form>
    </section>
  )
}

export default CertificateError
